import { render, staticRenderFns } from "./PazienteParametriVitaliListComponent.vue?vue&type=template&id=4989637c"
import script from "./PazienteParametriVitaliListComponent.vue?vue&type=script&lang=js"
export * from "./PazienteParametriVitaliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports